import { Input } from '@enterprise-ui/canvas-ui-react';
import classnames from 'classnames';
import React__default from 'react';
import { useTable } from '../utils/hooks.js';
import { getSelectAllStatus, getAllSelectedRows } from './utils.js';

var GroupSelectionCell = function GroupSelectionCell(_ref) {
  var dataTestId = _ref.dataTestId,
    groupRowData = _ref.groupRowData,
    groupId = _ref.groupId,
    rowSelection = _ref.rowSelection;
  var _useTable = useTable(),
    _useTable$state = _useTable.state,
    name = _useTable$state.name,
    selectedRows = _useTable$state.selectedRows,
    onRowSelect = _useTable$state.onRowSelect,
    columns = _useTable$state.columns;
  var pinned = columns.columnDefs.some(function (_ref2) {
    var pinned = _ref2.pinned;
    return pinned;
  });
  var columnClasses = classnames('C-TableAdvanced__bodyCell', {
    '--pinned': pinned
  });
  var hasRowSelection = !!rowSelection;
  var _getSelectAllStatus = getSelectAllStatus(selectedRows, groupRowData),
    isSelectAllChecked = _getSelectAllStatus.isSelectAllChecked,
    isIntermediate = _getSelectAllStatus.isIntermediate;
  var groups = groupId.split('-');
  var labelText = groups.length > 1 ? "".concat(groups[groups.length - 1], " in group ").concat(groups[groups.length - 2]) //most relevant groups are at the end of the array
  : groupId;
  return hasRowSelection && /*#__PURE__*/React__default.createElement("td", {
    className: columnClasses,
    "data-testid": dataTestId ? "".concat(dataTestId, "-selection-cell") : null
  }, /*#__PURE__*/React__default.createElement(Input.Checkbox, {
    checked: isSelectAllChecked,
    indeterminate: isIntermediate,
    "data-testid": dataTestId ? "".concat(dataTestId, "-selection-cell-checkbox") : null,
    id: "".concat(name, "-").concat(groupId) //use table name in case folks have multiple tables
    ,
    "aria-label": "".concat(isSelectAllChecked ? 'Deselect' : 'Select', " all rows within ").concat(labelText),
    onChange: function onChange(event) {
      var selections = getAllSelectedRows({
        checked: event.target.checked,
        selectableRows: groupRowData,
        selectedRows: selectedRows
      });
      onRowSelect && onRowSelect(selections);
    }
  }));
};

export { GroupSelectionCell as default };
